import { useEffect, useState } from 'react';
import api from '../services/api';
import { APP_VERSION } from '../config/version';

let versaoEmCache: string | null = null;

/** Versão do sistema (AAAA.M.D.N) registrada no banco pelo backend a cada novo build. */
export const useAppVersion = (): string => {
  const [versao, setVersao] = useState<string>(versaoEmCache || APP_VERSION);

  useEffect(() => {
    if (versaoEmCache) return;
    let ativo = true;
    api.get('/versao')
      .then((res: any) => {
        const v = res?.data?.versao;
        if (v) {
          versaoEmCache = v;
          if (ativo) setVersao(v);
        }
      })
      .catch(() => {});
    return () => { ativo = false; };
  }, []);

  return versao;
};
